import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { Observable } from 'rxjs';
import { Culture } from '../state/culture/culture';
import {
    ContentfulArrayContract,
    ContentfulEntryContract,
} from '../types/content-types/contracts';

export interface ContentQuery {
    [key: string]: string | number | boolean | undefined;
}

@Injectable({
    providedIn: 'root',
})
export class ContentResourceService {
    private baseUrl: string;
    private locale: string;
    private spaceId: string;
    private token: string;

    constructor(
        private httpClient: HttpClient,
        configService: ConfigService,
        @Inject(LOCALE_ID) locale: string
    ) {
        this.spaceId = configService.contentful.spaceId;
        this.token = configService.contentful.token;
        this.locale = Culture.toRcCultureCode(locale);

        this.baseUrl =
            configService.isDev || configService.isTest || configService.isStage
                ? 'https://preview.contentful.com'
                : 'https://cdn.contentful.com';
    }

    getEntryById<T extends ContentfulEntryContract>(id: string): Observable<T> {
        const url = `${this.baseUrl}/spaces/${this.spaceId}/entries/${id}`;
        const params = new HttpParams({
            fromObject: {
                access_token: this.token,
                locale: this.locale,
            },
        });

        return this.httpClient.get<T>(url, { params });
    }

    getEntries<T extends ContentfulArrayContract>(
        query: ContentQuery
    ): Observable<T> {
        const url = `${this.baseUrl}/spaces/${this.spaceId}/entries`;
        const params = new HttpParams({
            fromObject: {
                access_token: this.token,
                locale: this.locale,
                ...this.sanitizeQuery(query),
            },
        });

        return this.httpClient.get<T>(url, { params });
    }

    private sanitizeQuery(query: ContentQuery): Record<string, string> {
        const sanitized: Record<string, string> = {};

        for (const [key, value] of Object.entries(query)) {
            if (value !== undefined && value !== null) {
                sanitized[key] = String(value);
            }
        }

        return sanitized;
    }
}
